const formatNumber = (value) => {
  return value ? value.toLocaleString() : '';
};


const PerformanceComparison = (props) => {
  const platformData = props.platformData;

  return <div className="h-64">
    <h2 className="text-2xl mb-4">Performance Comparison</h2>

    <div className="grid grid-cols-3 gap-4 h-full pb-10">
      <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 backdrop-blur-sm border border-slate-700/50 p-6 relative rounded-2xl">
        <div className="absolute right-20 bottom-20 w-36 h-36 bg-gradient-to-br from-green-500/20 to-green-700/20 rounded-full blur-3xl"></div>
        <div className="absolute left-20 top-20 w-36 h-36 bg-gradient-to-br from-pink-500/20 to-pink-700/20 rounded-full blur-3xl"></div>
        <h3 className="text-lg font-bold mb-4 text-center">TikTok Total</h3>
        <div className="space-y-3">
          <div className="flex justify-between items-center text-xs">
            <span className="text-slate-400">Revenue:</span>
            <span className="font-semibold text-white">{platformData.tiktok.revenue.toLocaleString()}</span>
          </div>
          <div className="flex justify-between items-center text-xs">
            <span className="text-slate-400">COGs:</span>
            <span className="font-semibold text-white">{formatNumber(platformData.tiktok.cogs)}</span>
          </div>
          <div className="flex justify-between items-center text-xs">
            <span className="text-slate-400">Profit:</span>
            <span className="font-semibold text-green-400">{platformData.tiktok.profit.toLocaleString()}</span>
          </div>
          <div className="flex justify-between items-center text-xs">
            <span className="text-slate-400">ROI:</span>
            <span className="font-semibold text-white">{platformData.tiktok.roi}</span>
          </div>
        </div>
      </div>

      <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 backdrop-blur-sm border border-slate-700/50 p-6 relative rounded-2xl">
        <div className="absolute right-20 bottom-20 w-36 h-36 bg-gradient-to-br from-blue-500/20 to-blue-700/20 rounded-full blur-3xl"></div>
        <div className="absolute left-20 top-20 w-36 h-36 bg-gradient-to-br from-emerald-500/20 to-emerald-700/20 rounded-full blur-3xl"></div>
        <h3 className="text-lg font-bold mb-4 text-center">eBay Total</h3>
        <div className="space-y-3">
          <div className="flex justify-between items-center text-xs">
            <span className="text-slate-400">Revenue:</span>
            <span className="font-semibold text-white">{platformData.ebay.revenue.toLocaleString()}</span>
          </div>
          <div className="flex justify-between items-center text-xs">
            <span className="text-slate-400">COGs:</span>
            <span className="font-semibold text-white">{formatNumber(platformData.ebay.cogs)}</span>
          </div>
          <div className="flex justify-between items-center text-xs">
            <span className="text-slate-400">Profit:</span>
            <span className="font-semibold text-green-400">{platformData.ebay.profit.toLocaleString()}</span>
          </div>
          <div className="flex justify-between items-center text-xs">
            <span className="text-slate-399">ROI:</span>
            <span className="font-semibold text-white">{platformData.ebay.roi}</span>
          </div>
        </div>
      </div>

      <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 backdrop-blur-sm border border-slate-700/50 p-6 relative rounded-2xl">
        <div className="absolute left-20 top-20 w-36 h-36 bg-gradient-to-br from-orange-500/20 to-orange-700/20 rounded-full blur-3xl"></div>
        <h3 className="text-lg font-bold mb-4 text-center">Amazon Total</h3>
        <div className="space-y-3">
          <div className="flex justify-between items-center text-xs">
            <span className="text-slate-400">Revenue:</span>
            <span className="font-semibold text-white">{platformData.amazon.revenue.toLocaleString()}</span>
          </div>
          <div className="flex justify-between items-center text-xs">
            <span className="text-slate-400">COGs:</span>
            <span className="font-semibold text-white">{formatNumber(platformData.amazon.cogs)}</span>
          </div>
          <div className="flex justify-between items-center text-xs">
            <span className="text-slate-400">Profit:</span>
            <span className="font-semibold text-green-400">{platformData.amazon.profit.toLocaleString()}</span>
          </div>
          <div className="flex justify-between items-center text-xs">
            <span className="text-slate-400">ROI:</span>
            <span className="font-semibold text-white">{platformData.amazon.roi}</span>
          </div>
        </div>
      </div>

    </div>
  </div>;
}

export default PerformanceComparison;
